import { ViewerComponent } from 'feature-components'
import { Behavior, Callback } from 'thunderbolt-viewer-manager-types'
import { MenuContainerComponent } from 'feature-menu-container'
import { ILayoutDoneService } from '@wix/thunderbolt-symbols'

const noop = () => {}
const playHandler = async (component: ViewerComponent) => {
	const compRef: any = await component.getCompRef()
	compRef.mute && compRef.mute()
	compRef.play()
}
const videoApi = {
	play: playHandler,
	playPreview: playHandler,
	stopPreview: async (component: ViewerComponent) => {
		const compRef: any = await component.getCompRef()
		compRef.stop()
	},
}

const createCompBehaviorHandlers = (
	layoutDoneService: ILayoutDoneService
): {
	[componentType: string]: {
		[behaviorName: string]: (component: ViewerComponent, behavior: Behavior, callback?: Callback) => void
	}
} => ({
	SlideShowContainer: {
		nextSlide: async (component, _, callback = noop) => {
			const compRef: any = await component.getCompRef()
			layoutDoneService.enableLayoutDone(false)
			compRef.next(() => {
				layoutDoneService.enableLayoutDone(true)
				callback()
			})
		},
		prevSlide: async (component, _, callback = noop) => {
			const compRef: any = await component.getCompRef()
			layoutDoneService.enableLayoutDone(false)
			compRef!.previous(() => {
				layoutDoneService.enableLayoutDone(true)
				callback()
			})
		},
		moveToSlide: async (component, { params }, callback = noop) => {
			const compRef: any = await component.getCompRef()
			layoutDoneService.enableLayoutDone(false)
			const { slide } = params || {}
			compRef.moveToSlide({
				slideIndex: slide,
				callback: () => {
					layoutDoneService.enableLayoutDone(true)
					callback()
				},
			})
		},
	},
	StateBox: {
		changeState: async (component, { params }, callback = noop) => {
			const compRef: any = await component.getCompRef()
			layoutDoneService.enableLayoutDone(false)
			const { stateIndex } = params || {}
			compRef.moveToSlide({
				slideIndex: stateIndex,
				callback: () => {
					layoutDoneService.enableLayoutDone(true)
					callback()
				},
			})
		},
	},
	MediaPlayer: videoApi,
	Column: videoApi,
	StripColumnsContainer: videoApi,
	ClassicSection: videoApi,
	Section: videoApi,
	SlideShowSlide: videoApi,
	PageBackground: videoApi,
	HoverBox: videoApi,
	MusicPlayer: {
		play: async (component) => {
			const compRef: any = await component.getCompRef()
			compRef.play()
		},
		stop: async (component) => {
			const compRef: any = await component.getCompRef()
			compRef.stop()
		},
	},
	LottieEmbed: {
		play: async (component, _, callback = noop) => {
			const compRef: any = await component.getCompRef()
			await compRef.play()
			callback()
		},
		stop: async (component) => {
			const compRef: any = await component.getCompRef()
			compRef.stop()
		},
		pause: async (component) => {
			const compRef: any = await component.getCompRef()
			compRef.pause()
		},
	},
	MenuContainer: {
		open: (component, { params }) => {
			const { immediate, callbacks = {} } = params || {}
			const { onComplete = noop } = callbacks
			;(component as MenuContainerComponent).open(immediate).then(onComplete)
		},
		close: (component, { params }) => {
			const { immediate, callbacks = {} } = params || {}
			const { onComplete = noop } = callbacks
			;(component as MenuContainerComponent).close(immediate).then(onComplete)
		},
		animate: (component, { params }) => {
			const { animation, callbacks = {} } = params || {}
			const { onComplete = noop } = callbacks
			;(component as MenuContainerComponent).animateIn(animation).then(onComplete)
		},
	},
	Tabs: {
		setCurrentTabId: async (component, { params }) => {
			const compRef: any = await component.getCompRef()
			const { tabId } = params || {}
			compRef.setCurrentTabId(tabId)
		},
	},
	Slideshow: {
		setCurrentIndex: async (component, { params = {} }) => {
			const compRef: any = await component.getCompRef()
			compRef.setCurrentIndex(params)
		},
	},
})

export default createCompBehaviorHandlers
